export default __webpack_public_path__ + "static/media/femimed_recepcja_thumbnail.c77be5a7.webp";